var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlocksPlainQuoteOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30269 9.33333C3.30269 8.75611 3.61161 8.13421 4.30781 7.61206C4.45958 7.49824 4.62679 7.39204 4.80776 7.29556C5.16797 7.10352 5.34111 6.65147 5.13109 6.30144C4.97279 6.03761 4.64611 5.92162 4.36968 6.05671C2.94308 6.75393 2 7.96103 2 9.33333V13.3333C2 13.7015 2.29847 14 2.66666 14L5.33333 14C5.70152 14 6 13.7015 6 13.3333L6 10C6 9.63181 5.70152 9.33333 5.33333 9.33333H3.30269ZM9.30781 7.61206C8.61161 8.13421 8.30269 8.75611 8.30269 9.33333H10.3333C10.7015 9.33333 11 9.63181 11 10V13.3333C11 13.7015 10.7015 14 10.3333 14L7.66666 14C7.29847 14 7 13.7015 7 13.3333L7 9.33333C7 7.96103 7.94308 6.75393 9.36968 6.05671C9.64611 5.92162 9.97279 6.03761 10.1311 6.30144C10.3411 6.65147 10.168 7.10352 9.80776 7.29556C9.62679 7.39204 9.45958 7.49824 9.30781 7.61206ZM20 9H13V10H20V9ZM13 13H20V14H13V13ZM6 17H20V18H6V17Z",
    fill: "white",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocksPlainQuoteOff);
export default __webpack_public_path__ + "static/media/blocks_plain_quote_off.dc50b5bba03d012de7ae191de2f1ab5d.svg";
export { ForwardRef as ReactComponent };